/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors } from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

const privilege = [
  '',
  'Super Administrator',
  'Administrator',
  'Admin Cabang',
  'General User',
  'Dispatcher',
  'Limited User'
]

// *From Auth - Data will be received from auth provider
const userDefaults = {
  full_name: '', // From Auth
  privilege: privilege[4],
  photoURL: require('@/assets/images/portrait/small/avatar-s-11.jpg'), // From Auth
  token: '',
  username: '',
  fix_privilege: '',
  block_sspoin: '',
  block_top_rank: '',
  is_verified_email: '',
  is_verified_phone: ''
  // privilegeNumber: null,
}

// console.log(userInfoLocalStorage)

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  const userInfo = {}

  const userInfoLocalStorage =
    JSON.parse(localStorage.getItem('userInfo')) || {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key]
      ? userInfoLocalStorage[key]
      : userDefaults[key]
    if (key == 'privilege') {
      userInfo.privilegeNumber = privilege.indexOf(userInfo[key])
      userInfo[key] = privilege[userInfo[key]]
    }
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null)
      userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if ('ontouchstart' in window || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser: getUserInfo(),
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  is_touch_device: is_touch_device(),
  mainLayoutType: themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: 'default',
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList['pages'].data.filter(
    (page) => page.is_bookmarked
  ),
  theme: themeConfig.theme || 'light',
  themePrimaryColor: colors.primary,
  privilegeList: [
    { value: 2, label: 'Administrator' },
    { value: 3, label: 'Admin Cabang' },
    { value: 4, label: 'General User' },
    { value: 5, label: 'Dispatcher' },
    { value: 6, label: 'Limited User' }
  ],
  typeList: [
    { value: 0, label: 'Basic' },
    { value: 1, label: 'Premium' }
  ],

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null
}

export default state
